import Vue from "vue";
import routes from "./routes/index.js";
import storeModule from "./store-module/index.js";
import { Toast } from "vant";
import login from "./utils/login.js";
export default {
    routes: routes,
    storeModule: storeModule,
    login,
    main() {
        Vue.prototype.$showTitle = false;
        Vue.prototype.$bindInsurance = function() {
            console.log("APP版本：" + window.HmsApp.VERSION);
            window.HmsApp.goToPage({ pageCode: "11" }).then((data) => {
                if (data.statusCode == "0") {
                    this.getData();
                    Toast("绑定成功");
                } else {
                    Toast(data.msg);
                }
                console.log(data);
            });
        };
    },
};
